module.exports = __webpack_public_path__ + "static/media/22ESCWA12.89783c92.jpg";